import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgExitIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      {...props}
    >
      <path
        d="M23.6 20a3.79 3.79 0 0 0-.058-.625l7.667-7.667c.2-.2.2-.525 0-.725L29.025 8.8c-.2-.2-.525-.2-.725 0l-7.666 7.667a3.957 3.957 0 0 0-.625-.059c-.209 0-.425.025-.625.059L11.7 8.792c-.2-.2-.525-.2-.725 0l-2.183 2.183c-.2.2-.2.525 0 .725l7.667 7.667a3.955 3.955 0 0 0-.059.625c0 .208.025.425.059.625l-7.667 7.666c-.2.2-.2.525 0 .725l2.183 2.184c.2.2.525.2.725 0l7.667-7.667c.208.033.417.058.625.058.208 0 .425-.025.625-.058l7.667 7.667c.2.2.525.2.725 0l2.183-2.184c.2-.2.2-.525 0-.725l-7.667-7.666c.034-.209.059-.417.059-.625L23.6 20Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};

export default SvgExitIcon;
